import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { authApi } from './api';

export const sessionKey = ['auth', 'session'] as const;

export function useSession() {
  return useQuery({
    queryKey: sessionKey,
    queryFn: authApi.me,
    staleTime: 30_000,
    retry: false,
  });
}

export function clearClientSensitiveStorage() {
  const keysToRemove = ['lilius_tables', 'lilius_rates', 'lilius_menu', 'lilius_tx'];
  keysToRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore storage access errors
    }
  });
  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      queryClient.setQueryData(sessionKey, null);
      queryClient.clear();
      clearClientSensitiveStorage();
    },
  });
}
